import { render } from "./Moons.vue?vue&type=template&id=498320af&scoped=true"
import script from "./Moons.vue?vue&type=script&lang=js"
export * from "./Moons.vue?vue&type=script&lang=js"

import "./Moons.vue?vue&type=style&index=0&id=498320af&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498320af"]])

export default __exports__